/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compress_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Compress text in selected events" |
*
* @param {Compress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compress_aria_label = /** @type {((inputs?: Compress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compresser le texte dans les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text in ausgewählten Ereignissen komprimieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comprimi il testo negli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сжать текст в выбранных событиях")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprimir texto en eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("压缩选定事件中的文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのテキストを圧縮する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं में टेक्स्ट को संपीड़ित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comprimir texto em eventos selecionados")
	return /** @type {LocalizedString} */ ("Compress text in selected events")
});